import { useState } from 'react';
import isBoolean from 'lodash/isBoolean';

export function useToggle(initial = false): [boolean, (value?: any) => void] {
    const [isActive, setIsActive] = useState(initial);

    function toggleActive(value) {
        setIsActive(isBoolean(value) ? value : !isActive);
    }

    return [isActive, toggleActive];
}
